var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"select-expense-payment-method-modal","no-close-on-backdrop":"","title":"Métodos de pago del gasto","hide-footer":""}},[_c('totales'),_c('hr'),_c('list-payment-methods'),_c('buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }